import { get, isEmpty } from 'lodash-es';
import { hideOptions } from 'client/site-modules/shared/utils/hide-options';
import { getFeaturesByCategories } from 'client/site-modules/shared/utils/inventory/features-and-specs';
import { isPartnerDealer } from 'client/site-modules/shared/utils/dealer-details-utils';
import { getSortedOptionDescriptions } from 'client/site-modules/shared/utils/get-sorted-option-descriptions';

export function showFeaturesTab(vinData) {
  const isPartnerListing = isPartnerDealer(vinData);
  const featuresByCategories = getFeaturesByCategories(vinData);
  const features = getSortedOptionDescriptions(vinData);
  const upgrades = get(vinData, 'vehicleInfo.partsInfo.options', []);

  return (
    (isPartnerListing && !hideOptions(vinData) && !!upgrades.length) ||
    !isEmpty(featuresByCategories) ||
    !!features.length
  );
}
